import { copyToClipBoard } from "../../../Utils/utilities";
import GetRequiredAsterisk from "../GetRequiredAsterisk";
import images from "../../../images";
import React, { useEffect, useState } from "react";
import Svg from "../../Helper/Svg";
import FieldError from "./FieldError";

const FieldInput = ({
  autoComplete,
  copy,
  errors,
  floatingLabel,
  icon,
  inputMode,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  onMouseDown,
  placeholder,
  readOnly,
  required,
  rounded,
  touched,
  type,
  value,
}) => {
  const [fieldValue, setFieldValue] = useState(value ?? "");

  useEffect(() => {
    setFieldValue(value);
  }, [value]);

  const handleValueChange = (event) => {
    if (onChange) {
      return onChange(event);
    }

    setFieldValue(event.target.value);
  };

  const getFieldIcons = () => {
    if (!icon && !copy) {
      return null;
    }

    const iconComponent = icon ? (
      <button onClick={(event) => onClick && onClick(event)} onMouseDown={(event) => event.preventDefault()}>
        <Svg icon={icon} />
      </button>
    ) : null;

    const copyComponent = copy ? (
      <button type="button" onClick={() => copyToClipBoard(value)}>
        <Svg icon={images.icons.copy} />
      </button>
    ) : null;

    return (
      <div className="absolute right-0 mr-default flex items-center justify-center space-x-4">
        {iconComponent}
        {copyComponent}
      </div>
    );
  };

  const defaultClass = `block w-full bg-theme-secondary ${rounded} p-default text-theme-text peer`;
  const errorClass = errors?.[name] && touched?.[name] ? "border-2 border-theme-error-input" : "";

  return (
    <div className="w-full">
      <div className="relative flex items-center w-full">
        <input
          autoComplete={autoComplete}
          className={`${defaultClass} ${errorClass}`}
          id="fieldInput"
          inputMode={inputMode}
          name={name}
          onBlur={(event) => onBlur && onBlur(event)}
          onChange={(event) => handleValueChange && handleValueChange(event)}
          onFocus={(event) => onFocus && onFocus(event)}
          onMouseDown={(event) => onMouseDown && onMouseDown(event)}
          placeholder={floatingLabel ? " " : placeholder}
          readOnly={readOnly}
          required={required}
          type={type}
          value={fieldValue}
        />
        {floatingLabel && (
          <label
            className="absolute text-sm text-theme-text duration-300 ml-[0.35rem] transform -translate-y-4 pointer-events-none scale-75 top-4 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
            htmlFor="fieldInput"
          >
            {placeholder}
            <GetRequiredAsterisk required={required} />
          </label>
        )}
        {getFieldIcons()}
      </div>
      <FieldError errors={errors} touched={touched} name={name} />
    </div>
  );
};

FieldInput.defaultProps = {
  copy: false,
  floatingLabel: true,
  inputMode: "text",
  placeholder: " ",
  readOnly: false,
  rounded: "rounded-default",
  type: "text",
  value: "",
};

export default FieldInput;
